import $ from "jquery";

export const init = function () {
  let attempts = 0;

  /*--------------------------------------------------------------------------------------------------------------------------------------*/
  /*  Fragen und Antworten per Ajax im Klapper -------------------------------------------------------------------------------------------*/
  /*--------------------------------------------------------------------------------------------------------------------------------------*/
  let loading = {
    init: function (settings) {
      loading.config = {
        anchors: $(".accordion-grid-container.ajax-loading .card-title a"),
        target: ".ajax-content",
        root: "#ajax-elements",
      };
      $.extend(loading.config, settings);
      loading.setup();

      // let $this = $($(".accordion-grid-container .card-body")[0]);
      // $(".accordion-grid-container .card-title a:first").addClass("already-loaded");
      // $(".accordion-grid-container .card:first").addClass("active");
      // loading.url = $(".accordion-grid-container .card-title a:first").data("href");
      // loading.getContent($this, function () {
      //   $this.find(loading.config.target).show("hide");
      //   $(".accordion-grid-container .card-body").addClass("active");
      //   $(".accordion-grid-container .card:first .collapse").addClass("show");
      // });

      setTimeout(function () {
        let $first = $(".accordion-grid-container .card-title a:first");
        $first.trigger("click");
        $first.attr("aria-expanded", "true");
        $first.parents(".card").find(".collapse").addClass("show");
      }, 500);
    },
    setup: function () {
      loading.config.anchors.click(function (e) {
        if (!$(this).hasClass("already-loaded")) {
          e.preventDefault();
          $(this).addClass("already-loaded");
          loading.url = $(this).data("href");
          loading.manageStyles($(this));
        }
      });
    },
    manageStyles: function ($this) {
      $(".accordion-grid-container .card").removeClass("active");
      $(".accordion-grid-container .card .collapse").removeClass("show");
      loading.getContent($this.parents(".card"), function () {
        $this.find(loading.config.target).show();
      });
    },
    getContent: function ($this, callback) {
      $this
        .find(loading.config.target)
        .load(loading.url + " " + loading.config.root + " > *", callback);
    },
  };

  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      loading.init();
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
